<template>
    <RectangleTile @click="handleCardClick" v-interact background="background-tile-primary">




        <template v-slot:icon>
            <TileIcon>
                <v-img v-if="offerAndItsProgress.offer.icon" :src="offerAndItsProgress.offer.icon"></v-img>
            </TileIcon>
        </template>




        <template v-slot:details>
            <TileDetails>
                <template v-slot:name>{{ offerAndItsProgress.offer.name }}</template>
                <template v-slot:description>{{ offerAndItsProgress.offer.instructions }}</template>
            </TileDetails>
        </template>




        <template v-slot:actions>

            <TileCoins
                :coins_amount="offerAndItsProgress.offer.coins_amount"
                :offer-platforms="offerAndItsProgress.offer.platforms"
                :status="'primary'"
            />

        </template>


        <template v-slot:append-bottom>
            <v-divider class="my-2 w-100"></v-divider>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex flex-row justify-space-between mb-2">

                    <span class="text-body-2">Status</span>
                    <span class="text-body-2">
                        {{ (new Date(offerAndItsProgress.progress_info.last_started_at * 1000)).toDateString() }}
                    </span>

                </v-col>
            </v-row>

            <v-progress-linear class="progress-bar-completed" height="25" model-value="100" rounded>    

                <template #default>
                    <span class="progress-label weight-700 text-12">Completed</span>
                </template>

            </v-progress-linear>

        </template>


    </RectangleTile>
</template>



<script setup>
import { computed } from 'vue';
import { OfferStatusStore } from '@/store/OfferStatusStore';

import TileIcon from "@/components/Common/Tile-Icon.vue";
import TileCoins from "@/components/Common/Tile-Coins.vue";
import TileDetails from '@/components/Common/Tile-Details.vue';
import RectangleTile from '@/components/Tiles/Rectangle-Tile.vue';

const props = defineProps({
    id: Number,
});

const emit = defineEmits(['cardClicked']);

const offerStatusStore = OfferStatusStore();

const offerAndItsProgress = computed(() => {
    return offerStatusStore.completedOffers[props.id];
});

const handleCardClick = () => {
    // Only set the selected offer if it exists
    if (offerAndItsProgress.value) {
        offerStatusStore.setSelectedOffer(offerAndItsProgress.value);
        emit('cardClicked', offerAndItsProgress.value);
    }
};
</script>
